import { useMemo, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import PropTypes from 'prop-types';

import { VerticalThreeDotsIcon } from 'src/assets/icons/VerticalThreeDotsIcon';

import { useStyles } from './useStyles';

export const ProjectActionsDropdown = ({ actions, getActions, project, className }) => {
  const styles = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const localActions = useMemo(
    () => actions || getActions(project),
    [actions, getActions, project]
  );

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.preventDefault();
    setAnchorEl(null);
  };

  const handleAction = (e, action) => {
    setAnchorEl(null);
    action.onClick(e, project);
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        className={className}
      >
        <VerticalThreeDotsIcon className={styles.actionDots} />
      </IconButton>
      <Menu
        classes={{ paper: styles.paper }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleModalClick}
      >
        {localActions.map((action) => (
          <MenuItem
            key={action.label}
            onClick={(e) => {
              handleAction(e, action);
            }}
            className={styles.item}
            disabled={action.disabled}
          >
            {action.icon}
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

ProjectActionsDropdown.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    })
  ),
  getActions: PropTypes.func,
  project: PropTypes.object,
};

ProjectActionsDropdown.defaultProps = {
  className: '',
  actions: null,
  getActions: null,
  project: null,
};
